import { Search } from "@certn/cascadia-react";
import { Stack } from "@certn/cascadia";
import { useTranslation } from "react-i18next";
import { useQueryParams } from "../../../../hooks/useQueryParams";

export function AdjudicationFilters() {
  const { t } = useTranslation();
  const { params, setParam } = useQueryParams();

  const handleSearchChange = (searchValue: string) => {
    setParam("search", searchValue);
    // Reset to first page when searching
    if (searchValue !== params.search) {
      setParam("page", "1");
    }
  };

  return (
    <Stack orientation="horizontal" gap="space-3" align="center">
      <Search
        value={params.search ?? ""}
        onChange={handleSearchChange}
        testID="adjudication-search-filter"
        aria-label={t("Search adjudication rubrics")}
        placeholder={t("Search rubrics...")}
        compact={false}
        maxWidth="400px"
      />
    </Stack>
  );
}
